import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaChartBar, FaUserSlash } from "react-icons/fa";
import { AlunoContext } from "../../context/AlunoContext";
import FiltroAlunos from "./FiltroAlunos";
import AlunoCard from "./AlunoCard";
import Paginacao from "./Paginacao";
import ModalDetalhes from "./ModalDetalhes";
import { exportarAlunos } from "../../utils/exportarListaAlunos"; // ✅ IMPORTAÇÃO
import "./ListaAlunos.css";

const ListaAlunos = () => {
  const { ativos, desativarAluno } = useContext(AlunoContext);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroClasse, setFiltroClasse] = useState("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [alunoSelecionado, setAlunoSelecionado] = useState(null);
  const navigate = useNavigate();

  const alunosFiltrados = ativos.filter((aluno) =>
    (
      aluno.nome_completo.toLowerCase().includes(filtroNome.toLowerCase()) ||
      (aluno.codigo_aluno || "").toLowerCase().includes(filtroNome.toLowerCase())
    ) &&
    (filtroClasse === "" || aluno.classe === filtroClasse)
  );

  const alunosPorPagina = 10;
  const totalPaginas = Math.ceil(alunosFiltrados.length / alunosPorPagina);
  const alunosPaginados = alunosFiltrados.slice((paginaAtual - 1) * alunosPorPagina, paginaAtual * alunosPorPagina);

  // ✅ FUNÇÃO DE EXPORTAÇÃO
  const onExportar = (formato) => {
    exportarAlunos(
      alunosFiltrados,
      formato,
      "Lista de Alunos Ativos",
      `ACADE_ListaAlunos_${new Date().toISOString().slice(0, 10)}`
    );
  };

  return (
    <div className="lista-alunos">
      <h2>Lista de Alunos Ativos</h2>

      <div className="top-bar">
        <button onClick={() => navigate("/estatisticas")} className="btn-azul">
          <FaChartBar /> Ver Estatísticas
        </button>
        <button onClick={() => navigate("/alunos-desativados")} className="btn-laranja">
          <FaUserSlash /> Ver Alunos Desativados
        </button>
      </div>

      {/* ✅ Passar função de exportação */}
      <FiltroAlunos
        filtroNome={filtroNome}
        setFiltroNome={setFiltroNome}
        filtroClasse={filtroClasse}
        setFiltroClasse={setFiltroClasse}
        onExportar={onExportar}
      />

      <div className="lista-container">
        {alunosPaginados.length > 0 ? (
          alunosPaginados.map((aluno) => (
            <AlunoCard
              key={aluno.id}
              aluno={aluno}
              onVisualizar={setAlunoSelecionado}
              onDesativar={desativarAluno}
            />
          ))
        ) : (
          <p>Nenhum aluno encontrado.</p>
        )}
      </div>

      <Paginacao
        paginaAtual={paginaAtual}
        totalPaginas={totalPaginas}
        setPaginaAtual={setPaginaAtual}
      />

      {alunoSelecionado && (
        <ModalDetalhes aluno={alunoSelecionado} onClose={() => setAlunoSelecionado(null)} />
      )}
    </div>
  );
};

export default ListaAlunos;
